import React from 'react';

import HowItWorksStep1SVG from "../../components/Images/HowItWorksStep1SVG"
import HowItWorksStep2SVG from "../../components/Images/HowItWorksStep2SVG"
import HowItWorksStep3SVG from "../../components/Images/HowItWorksStep3SVG"
import HowItWorksStep4SVG from "../../components/Images/HowItWorksStep4SVG"
import  KavitaImg from "../../pages/WritersBenefit/Author/Images/Kavita.jpg"
import  WordsImg from "../../pages/WritersBenefit/Author/Images/Words.jpg"
import  AnandImg from "../../pages/WritersBenefit/Author/Images/Anand.jpg"
import { commonFAQ } from '../../constants';



const tamil = {
  introduction_heading :'எழுத்தாளராக வேண்டும் என்னும் உங்களது கனவுகளுக்கு உயிர்கொடுங்கள்!',
  create_novel_button_text: "புதிய நாவல் ஒன்றை எழுதத் துவங்குங்கள்!",
  rewards_title: <>  வெகுமதிகளும் நன்மைகளும் </>,
  rewards_para_text: <>உங்களுக்குப் பிடித்த நாவலை எழுதுவதன் மூலமாக குறைந்தபட்சம் ஒரு 1 லட்சத்திலிருந்து அதிகபட்சமாக 10 லட்சம் வரையிலும் சம்பாதிக்கும் வாய்ப்பைப் பயன்படுத்திக் கொள்ளுங்கள்.</>,
  rewardsAndBenefitsArray: [
    {
      heading: 'New Story Bonus 🖋️',
      subHeading: <>சுயமாக எழுதப்பட்ட குறைந்தபட்ச வார்த்தைகளின் எண்ணிக்கையைக் கடக்கும் ஒவ்வொரு நாவலும் வெகுமதிக்குத் தகுதிபெறும்</>,
      tableHeadings: ['குறைந்தபட்ச வார்த்தைகள்   ', ' வெகுமதி'],
      table: [
        {
          wordCount: '30,000',
          reward: '₹3000',
        },
      ],
      note: <>பிறரது எழுத்துக்களோ அல்லது பாலியல் தொடர்பான எழுத்துக்களோ அனுமதிக்கப்படாது.</>,
      extraNotes: [
        {
          no: 1,
          text: ' கட்டாயமாக Writer Benifit Program [WBP] ற்காக விண்ணப்பித்து ஒப்பந்த உறுதிமொழியை ஏற்க வேண்டும்.',
        },
        {
          no: 2,
          text: '30,000 வார்த்தைகளைக் கடந்தவுடனே கூட ஒப்பந்த உறுதிமொழியை ஏற்கலாம்.',
        },
        {
          no: 3,
          text: 'ஒப்பந்தம் கையெழுத்தானவுடன், உங்களது நாவல் எங்களது குறைந்தபட்ச மதிப்பீடுகளில் தேர்ச்சி பெறும்பட்சத்தில் ஒவ்வொரு மாதமும் முதல் வாரத்தில் வழங்கப்படும் மாதாந்திர கட்டணச் சுழற்சி முறைக்கு அங்கீகரிக்கப்படும். ',
        },
      ],
    },
    {
      heading: 'Daily Update Bonus ⭐',
      subHeading: 'எழுதப்பட்ட சொற்களின் எண்ணிக்கை மற்றும் கதையின் தரத்தின் அடிப்படையில் வழங்கப்படும் .',
      tableHeadings: ['வார்த்தை எண்ணிக்கை(பிரதி மாதம்) ', 'வெகுமதி'],
      table: [
        {
          wordCount: '30,000  ',
          reward: 'வெகுமதி இல்லை ',
        },
        {
          wordCount: ' 30,000 - 50,000 ',
          reward: '₹2000',
        },
        
        {
          wordCount: '50,000 க்கு மேல்',
          reward: '₹6000',
        },
      ],
      note: <>ஒவ்வொரு மாதமும் அதிகபட்சமாக ஐந்து நாட்கள் வரையிலும் எழுதாமல் தவிர்த்தாலும் பிழையில்லை.</>,
      extraNotes: [
        {
          no: 1,
          text: <> உங்களது புத்தகம் WBP என்ற Writers Benifit Program ற்குத் தேர்ந்தெடுக்கப்பட்டதில் இருந்து ஒவ்வொரு மாதத்தின் முதல் தேதியில் எவ்வளவு வெகுமதி என்பது கணக்கிடப்படும்.</>,
        },
        {
          no: 2,
          text: <>  நீங்கள் பெறும் வெகுமதிக்கான பணப் பரிவர்த்தனை ஒவ்வொரு மாதத்தின் முதல் எட்டாம் தேதிக்குள்ளாக உங்களது வங்கிக் கணக்கிற்கு அனுப்பப்படும்.   </>,
        },
        {
          no:3,
          text : <>. மாதத்தின் இடையில் கையெழுத்தாகும் ஒப்பந்தத்திற்கான தொகை அடுத்த மாதத்தின் மாதாந்திர கட்டணச் சுழற்சியின் அடிப்படையில் மாதத்தின் முதல் வாரத்தில் வழங்கப்படும்.</>
        }
      ],
    },
    {
      heading: 'Completion Bonus 🚀',
      subHeading: 'ஆசிரியர் விரும்பினால் அவர் இதுவரையிலும் எழுதியிருக்கும் சொற்களின் எண்ணிக்கையைப் பொறுத்து இந்த ஊக்கத்தொகை வழங்கப்படும். ',
      tableHeadings: ['சொற்களின் எண்ணிக்கை(ஒட்டுமொத்தம்)', 'வெகுமதி'],
      table: [
        {
          wordCount: ' 2,50,000',
          reward: 'வெகுமதி இல்லை           ',
        },
        {
          wordCount: '2,50,000 - 3,50,000',
          reward: '₹5000',
        },
        {
          wordCount: '3,50,000 - 5,00,000',
          reward: '₹10,000',
        },
        {
          wordCount: '5,00,000 க்கு மேல் ',
          reward: '₹25,000',
        },
      ],
      note: <>கட்டாயமாக கதை பெரும்பாலானோர்களின் மனதைக் கவரும் விதமாக முடிந்திருக்க வேண்டும்.</>,
      extraNotes: [
        {
          no: 1,
          text: <>  கதையை இடையில் நிறுத்திக் கொள்ள விரும்பும் எழுத்தாளர்கள் இந்த ஊக்கத் தொகையைப் பெற எங்களது அலுவலக மின்னஞ்சல் முகவரிக்கு உங்களது கதையின் தலைப்பு மற்றும் எழுத்தாளரின் பெயரை அனுப்பி விண்ணப்பிக்கலாம்.</>,
        },
        {
          no: 2,
          text: <> ஊக்கத் தொகைக்கான உங்களது விண்ணப்பம் கிடைக்கப்பெற்றவுடன் எங்களது ஆசிரியர் குழு கதையை மதிப்பீடு செய்யும். ஊக்கத்தொகை பெறத் தகுதியான கதையாக ஆசிரியர்குழு பரிந்துரைத்தால் உங்களது பணம் செலுத்தப்படும். </>,
        },
      ],
    },
  ],
  deadline_content: <>   <span>திட்டத்தில் இணைவதற்கான காலக்கெடு :  </span><span role="img" aria-label="finish flag">🏁</span>   </>,
  deadline_to_enter_button: "பாக்கெட் நாவலில் உங்களது எழுத்துப் பயணத்தைத் தொடருங்கள்.",
  deadline_date:31,
  deadline_date_suffix:"",
  days_or: "days or " ,
  months_to_go:" months to go !! ",
  monthInWords:"December",
  month:11,
  year: 2022,
  deadline_subheading: 'ஒருமுறை WBP திட்டத்தில் இணைந்து கொண்டால் வாழ்நாள் முழுவதும் மேற்கண்ட ஊக்கத் தொகை மற்றும் வெகுமதிகளைப் பெறத் தகுதியுடைவராவீர்கள்',
  howItWorksArray : [
    {
      step: '1',
      instruction:<>முதல் முப்பதாயிரம் வார்த்தைகளை எழுதி ஒப்பந்தத்திற்கு விண்ணப்பிக்கவும்.✍️</>,
        stepSVG:HowItWorksStep1SVG
    },
    {
      step: '2',
      instruction:<>ஒப்பந்ததில் கையொப்பமிட்டு புதிய கதையைத் துவங்கியதற்கான ஊக்கத் தொகையைப் பெறுங்கள்.</>,
        stepSVG:HowItWorksStep2SVG
  
    },
    {
      step: '3',
      instruction:<>தினமும் தொடர்ச்சியாக எழுதுவதன் மூலமாக தினசரி எழுதுவதற்கான ஊக்கத் தொகையை ஒவ்வொரு மாதமும் பெறுங்கள்.</>,
        stepSVG:HowItWorksStep3SVG
  
    },
    {
      step: '4',
      instruction:<>உங்களது கதை 2,50,000 வார்த்தைகளைக் கடந்து அதிகப்படியான வாசகர்களையும் பெற்றிருக்கும்பட்சத்தில் உங்களது கதை ஒலி புத்தகமாக வெளியிடத் தகுதிபெறும். ஒலிப் புத்தகமாகத் தகுதிபெற்றால் சிறப்பு ஊக்கத் தொகை வழங்கப்படும். </>,
        stepSVG:HowItWorksStep4SVG
  
    },
  ],
  step: "STEP",
  popularWritersArray : [
    {
      writerName: 'Kavita verma ',
      novelName: 'Mein Tere Chandani  ன் ஆசிரியர் ',
      plays: '9.8M',
      words: '820K',
      writerImgSrc: KavitaImg,
    },
    {
      writerName: 'Words Queen',
      novelName: 'Fake Love ன் ஆசிரியர்',
      plays: '7.7M',
      words: '540K',
      writerImgSrc: WordsImg,
    },
    {
      writerName: 'Anand Usha Borkar',
      novelName: 'Megh - Ek Shraap ன் ஆசிரியர்',
      plays: '1.8M',
      words: '720K',
      writerImgSrc: AnandImg,
    },
  ],
  popular_writter: 'பிரபல எழுத்தாளர்கள்',


  faq: <strong>அடிக்கடி கேட்கப்படும் கேள்விகள்</strong>,
  frequentlyAskedQuestionsArray : commonFAQ,
  
  write_home_earn_stable_income_text :'வீட்டில் இருந்தபடியே நிலையான வருமானமும் ஈட்ட விரும்பினால் பாக்கெட் நாவலில் எழுதுங்கள். ',
  write_home_earn_stable_income_subheading : "இப்போதே உங்களது எழுத்துப் பயணத்தைத் தொடருங்கள். லட்சக்கணக்கான வாசர்கர்களைப் பெறுவதோடு வருடத்திற்கு 10 லட்சம் வரையிலும் வருமானம் பெறுங்கள்.",
  create_new_novel :"புதிய நாவல் ஒன்றை எழுதத் துவங்குங்கள்! "
 
}

// console.log(hindi.writer_dream_text)
export default tamil;
